const mfaActionTypes = {
  UPDATE_STATE: 'UPDATE_STATE',
  LOAD_AUTH_METHODS: 'LOAD_AUTH_METHODS',
};

export { mfaActionTypes as default };
